<template>
  <transition name="fade-slide" mode="out-in">
    <div
      v-if="etapa === 'confirmacion'"
      key="confirmacion"
      :class="['modal-contenido', { cerrando }]"
    >
      <img :src="advertencia" class="icon-warning" />
      <div class="body">
        <h1 class="tituloPregunta h1-heroMuni">
          ¿Estás seguro que desea salir?
        </h1>
        <div class="acciones">
          <button class="h2-heroMuni" @click="confirmar">Sí</button>
          <button class="h2-heroMuni" @click="cerrarConAnimacion">No</button>
        </div>
      </div>
    </div>

    <div v-else key="despedida" :class="['contenido-despedida', { cerrando }]">
      <ThemedIcon name="LuqueLogoMuni" alt="Logo" class="logo" />
      <div>
        <h1 class="titulo h1-heroMuni">¡Gracias por tu trabajo!</h1>
        <p class="subtitulo h2-defaultMuni">Crecemos juntos</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from "vue";
import advertencia from "../../../assets/images/LuqueLogoError.svg";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { cerrarSesion } from "@/services/auth/logoutService";
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";

const emit = defineEmits(["close-modal", "confirmado"]);

const etapa = ref("confirmacion");
const router = useRouter();
const store = useStore();
const cerrando = ref(false);
function confirmar() {
  if (navigator.vibrate) navigator.vibrate(10);

  etapa.value = "despedida";

  setTimeout(() => {
    // Limpiar cookies de push
    const clearStr = "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    const clearStrDomain =
      "expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.ofidi.com.ar;";
    document.cookie = `rutaPush=; ${clearStr}`;
    document.cookie = `rutaPush=; ${clearStrDomain}`;
    document.cookie = `pushId=; ${clearStr}`;
    document.cookie = `pushId=; ${clearStrDomain}`;

    cerrarSesion(() => {
      store.dispatch("mockOutAction");
      router.push("/login");
      store.commit("SET_LOADING", false);
    });
    emit("close-modal");
  }, 2000);
}
function cerrarConAnimacion() {
  cerrando.value = true;

  setTimeout(() => {
    emit("close-modal");
  }, 250); // mismo tiempo que tu animación
}
</script>

<style scoped>
.modal-contenido {
  background: var(--bg-popup);
  border-radius: 0.5rem;
  display: flex;
  gap: 5.008vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40vw;
  height: 47vh;
  color: var(--text-primary);
  animation: modalIn 0.35s ease;
}
.modal-contenido {
  max-height: 100%;
  overflow-y: hidden;
}

@keyframes modalIn {
  0% {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-contenido img {
  max-width: 100%;
  height: auto;
}
.acciones {
  display: flex;
  gap: 1.83vw;
  margin-top: 5.008vh;
}
.acciones button {
  display: flex;
  width: 13.47vw;
  padding: 0.835vh 0.732vw;
  justify-content: center;
  align-items: center;
  border-radius: 0.625rem;
}
.acciones button {
  color: var(--bg-popup);
  background: var(--text-primary);
  border: none;
  outline: none;
  box-shadow: none;
  transition: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.acciones button:active,
.acciones button:focus,
.acciones button:hover {
  box-shadow: none;
  outline: none;
  filter: none;
}

.acciones button:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

.acciones button:active {
  transform: scale(0.96);
}
.contenido-despedida {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.339vh;
  margin: auto;
  height: 100%;
  justify-content: center;
  width: 40vw;
  height: 47vh;
  color: var(--text-primary);
}
.logo {
  width: 16.105vw;
  height: 11.185vh;
}
.tituloPregunta {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.titulo {
  color: var(--color-success);
  text-align: center;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* ------------------ MOBILE ------------------ */
@media (max-width: 768px) {
  .modal-contenido {
    gap: 1.27vh;
    min-width: 280px;
    width: 100%;
    height: 240px;
    max-height: unset;
    padding: 20px 16px;
    border-radius: 1rem;
    justify-content: flex-start;
  }
  .contenido-despedida {
    gap: 3.339vh;

    min-width: 280px;
    height: 240px;
  }
  .logo {
    width: 45.78vw;
    height: auto;
  }
  .icon-warning {
    width: 11.11vw;
  }
  .tituloPregunta {
    text-align: center;
  }
  .body {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .acciones {
    flex-direction: column;
    align-items: center;
    gap: 1.27vh;
    margin: unset;
  }
  .acciones button {
    display: flex;
    width: 41.64vw;
    padding: 0.96vh 0.732vw;
    justify-content: center;
    align-items: center;
    border-radius: 0.625rem;
    font-size: 16px;
  }
  .acciones button:active {
    transform: scale(0.96);
    filter: brightness(0.9);
  }
  .modal-contenido,
  .contenido-despedida {
    animation: slideUpMobile 0.35s ease;
  }

  .modal-contenido.cerrando,
  .contenido-despedida.cerrando {
    animation: slideDownMobile 0.25s ease forwards;
  }

  @keyframes slideDownMobile {
    0% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(100%);
      opacity: 0;
    }
  }

  @keyframes slideUpMobile {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
